import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import { getLocale } from './utils/local.utils';

const locale = getLocale();

const loadLocalTranslations = () => {
    const localeMap: Record<string, string> = {
        'en-US': 'en-US',
        ar: 'ar',
        de: 'de',
        'es-ES': 'es-ES',
        'es-MX': 'es-MX',
        fr: 'fr',
        it: 'it',
        ja: 'ja',
        ko: 'ko',
        pl: 'pl',
        'pt-BR': 'pt-BR',
        ru: 'ru',
        tr: 'tr',
        'zh-CN': 'zh-CN'
    };

    const fileLocale = localeMap[locale] || 'en-US';

    const translations = require(`../../i18n/translations/messages_${fileLocale}.json`);
    return translations;
};

const loadEnglishTranslations = () => {
    const englishTranslations = require(`../../i18n/translations/messages_en-US.json`);
    return englishTranslations;
};

const initializeI18n = () => {
    const localTranslations = loadLocalTranslations();
    const englishTranslations = loadEnglishTranslations();

    const resources = {
        [locale]: {
            translation: localTranslations
        },
        'en-US': {
            translation: englishTranslations
        }
    };

    // @ts-ignore
    i18n.use(ICU)
        .use(initReactI18next)
        .init({
            lng: locale,
            resources,
            fallbackLng: 'en-US',
            fallbackNS: 'translation',
            load: 'currentOnly',
            preload: false,
            keySeparator: '::',
            react: {
                useSuspense: false,
                transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'mark']
            },
            interpolation: {
                escapeValue: false
            }
        });
};

initializeI18n();

export default i18n;
